import instance from "../apis/axiosConfig";

// CREATE TEAM
export const createTeam = (data) => {
  return instance.post("teams/create", data);
};

// GET ALL TEAM
export const getAllTeams = (page, limit) => {
  return instance.get(`teams/all?page=${page}&limit=${limit}`);
};

// UPDATE TEAM
export const updateTeam = (id, data) => {
  return instance.post(`teams/update/${id}`, data);
};

// DELETE TEAM
export const deleteTeam = (id) => {
  return instance.delete(`teams/delete/${id}`);
};

// UPDATE PUBLISH
export const updatePublishStatus = (id, data) => {
  return instance.post(`teams/update-publish-status/${id}`, data);
};

// UPDATE LEADER
export const updateLeaderStatus = (id, data) => {
  return instance.post(`teams/update-leader-status/${id}`, data);
};

// UPDATE TEAM IMAGE
export const updateTeamImage = (id, data) => {
  return instance.post(`teams/update-image/${id}`, data);
};
// UPDATE TEAM PRIORITY
export const updateTeamPriority = (data) => {
  return instance.post("teams/priority", data);
};